import { useRoutes } from '@/shared/routes';

export const aggReportsRoutes = [
  {
    name: useRoutes.AGG_REPORT_LIST_NAME,
    path: useRoutes.AGG_REPORT_LIST_PATH,
    component: () => import('@/pages/AggregatedData'),
  },
  {
    name: useRoutes.AGG_REPORT_ITEM_NAME,
    path: useRoutes.AGG_REPORT_ITEM_PATH,
    component: () => import('@/pages/AggregatedDataItem'),
  },
];
